import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import {
  ExportTemplatePayload,
  Template
} from '@utils/types/organization/export-template.ts';

const postExportTemplate = async (
  customerId: number,
  payload: ExportTemplatePayload
) => {
  const formData = new FormData();
  formData.append('name', payload.name);
  if (payload.template_docx)
    formData.append('docx_template', payload.template_docx);
  if (payload.template_example)
    formData.append('example_template', payload.template_example);
  // Append even empty strings if your API expects the field present:
  if (payload.prompt !== undefined)
    formData.append('prompt', payload.prompt ?? '');
  if (payload.type) formData.append('template_type', payload.type);

  const url = POST_URL(String(customerId)).exportBoTemplate;
  const { data } = await Axios.post<Template>(url, formData); // no manual headers
  return data;
};

export const useAddExportBoTemplate = (customerId: number) => {
  const queryClient = useQueryClient();
  return useMutation<Template, AxiosError<BaseError>, ExportTemplatePayload>(
    payload => postExportTemplate(customerId, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.exportTemplates());
      },
      useErrorBoundary: false
    }
  );
};
